import {AppState} from "../RootReducer";
import {createSelector} from "reselect";
export const getRewards = (state : AppState) => state.rewards.rewards;
export const getMessages = (state : AppState) => state.message?.messages;
export const getMessageNotificationUnreadCount = (state : AppState) => state.message?.unread ?? 0;
export const getBonusOffers = (state : AppState) => state.bonus.offers;
export const getLastSeenBonusOffer = (state : AppState) => state.bonus.lastSeenBonusOffer;
export const getHasFetchedLastSeenBonusOffer = (state : AppState) => state.bonus.hasFetchedLastSeenBonusOffer;
export const getMessageNotificationUnreadCountFromBalanceUpdater = (state: AppState) => state.user.unreadMessages
export const getUnreadNotificationsCount = createSelector([getBonusOffers, getLastSeenBonusOffer, getHasFetchedLastSeenBonusOffer, getRewards, getMessageNotificationUnreadCount, getMessageNotificationUnreadCountFromBalanceUpdater],
    (offers, lastSeenBonusOffer, done, rewards, notificationCount, notificationCountFromUpdate = 0)=>{
    let offerCount  = 0;
    if(done) {
        offerCount =  offers?.filter(o => (o?.id ?? 0) > lastSeenBonusOffer ).length ?? 0;
    }
    let nrOfRewards = rewards.filter(r => !r.messageRead).length;
    let count = notificationCount;
    if(notificationCount == 0 && notificationCountFromUpdate > 0){
        count = notificationCountFromUpdate
    }
    return offerCount + count + nrOfRewards;
});

export const getUnseenBonusOffers = createSelector([getBonusOffers, getLastSeenBonusOffer, getHasFetchedLastSeenBonusOffer],
    (offers, lastSeenBonusOffer, done) => {
    let offerCount : number = offers?.filter(o => (o?.id ?? 0) > lastSeenBonusOffer ).length ?? 0;
    return done ? offerCount : 0;
})

export const getUnseenRewards = createSelector([getRewards],(rewards) => {
    return rewards.filter(r => !r.messageRead).length;
})

export const getMessagesStatus = (state: AppState) => state.message?.status;
export const getMessagesHasMore = (state: AppState) => state.message?.hasMore;
export const getMessagesCurrentOffset = (state: AppState) => state.message?.currentOffset;
export const getUnreadMessagesCount = getMessageNotificationUnreadCount;